export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_TEKAY_fragment_3.814c7844.jpg";